<template lang="html">
  <div class="" style="width: 400px">
    <br>
    <Form ref="form" v-if="form" :label-width="160" @submit.native="post(form)" :model="form" :show-message="false">
      <Row>
        <Col offset="6" span="24"><h2>Carica o modifica un bene</h2><br><br></Col>
        <Col span="24"><FormItem label="Nome bene" :rules="req" prop="name">
          <Input v-model="form.name"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Comprato da" prop="bought_from">
          <Input v-model="form.bought_from"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Valore €" prop="amount">
          <NumInput v-model="form.amount"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Data" prop="date">
          <LocalDate v-model="form.date"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Numero fattura" prop="n_fatt">
          <Input v-model="form.n_fatt"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Tipo bene">
          <RadioGroup v-model="form.is_immaterial">
            <Radio :label="0">
              Materiale
            </Radio>
            <Radio :label="1">
              Immateriale
            </Radio>
          </RadioGroup>
        </FormItem></Col>
        <Col span="24" style="text-align:center">
          <FormItem class="">
            <Button type="error" @click="$emit('close')">
              Annulla
            </Button>
            &nbsp;
            <Button type="primary" @click="post(form)">
              Salva
            </Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  props: [
    'edit',
  ],

  data () {
    return {
      form: this.edit ? this._.clone(this.edit) : {},
    }
  },

  computed: {
  },

  mounted() {
  },

  methods: {
  post(data) {
    this.$refs.form.validate((valid) => {
      if (valid) {
        data.company_id = this.$store.company.id
        var is_new = !data.id
        this.$http.post('inventory/create', data).then(res => {
          this.$emit('close')
          this.$root.$emit('inventory')
        })
      } else {
        this.$Message.error('Controllare gli errori');
      }
    })
  },
  }


}
</script>

<style lang="css">
</style>
